// eslint-disable-next-line unicorn/no-null
export const CustomCheckboxIcon: React.FC = () => null;
